export const triggeredEventsSituationMapped = {
  0: 'NÃO VISUALIZADO',
  1: 'VISUALIZADO',
  2: 'RESOLVIDO',
  3: 'PENDENTE'
}
